import { useGetAuth0MeQuery } from '@/store/api/userApi';
import { hasActionPermission } from '@/utils/permissionMenuUtils';

export const usePermissions = () => {
  const { data: auth0MeData } = useGetAuth0MeQuery();
  const allowedActions = auth0MeData?.user?.allowed_ui_actions || [];

  const hasPermission = (permission: string): boolean => {
    return allowedActions.includes(permission);
  };

  const canAdd = (module: string): boolean => {
    return hasActionPermission(module, 'add', allowedActions);
  };

  const canEdit = (module: string): boolean => {
    return hasActionPermission(module, 'edit', allowedActions);
  };

  const canDelete = (module: string): boolean => {
    return hasActionPermission(module, 'delete', allowedActions);
  };

  const canView = (module: string): boolean => {
    return hasActionPermission(module, 'view', allowedActions);
  };

  const canExecute = (module: string): boolean => {
    return hasActionPermission(module, 'execute', allowedActions);
  };

  return {
    hasPermission,
    canAdd,
    canEdit,
    canDelete,
    canView,
    canExecute,
    allowedActions,
  };
};

export default usePermissions;
